module.exports = __webpack_public_path__ + "img/product_iteration.b69720fa.svg";